// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../node_modules/less-loader/dist/cjs.js!./base/CampaignInfoDisplay.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yKZxZ7_zTJ8Er0w7_dcD {
  font-size: var(--campaign-info-label-font-has-many-multi-desktop);
}
.Y2O0YRyl7hvj1TQHG5Xj {
}
.Q0iBzF3PcN6LLsH4z8zi {
}
.Q0iBzF3PcN6LLsH4z8zi[data-has-many='true'] {
  font-size: var(--campaign-info-dynamic-value-font-has-many-multi-desktop);
}
.Q0iBzF3PcN6LLsH4z8zi[data-timer='true'][data-collapsed='false'][data-has-many='true'] {
  min-width: var(--campaign-info-dynamic-value-timer-min-width);
  display: inline-block;
  text-align: start;
}
.ja4HTht59n1byOytks3k {
}
.RZToHNGn3SEYLQcQDiiv {
}
.eP98PbckEgQoqxuPoo3V {
}
.w2fatjfcfjSZhNxKllsl img,
.w2fatjfcfjSZhNxKllsl svg {
  display: inline;
}
.w2fatjfcfjSZhNxKllsl {
}
.iz3438uL4IdaK0y59yJo {
}
.EmqAQ1Mz2234vTYgk0KM {
}
.b3Ehg06ayyGYUuVQ7c70 {
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .yKZxZ7_zTJ8Er0w7_dcD {
    font-size: var(--campaign-info-label-font-has-many-multi-mobile, 13px);
  }
  .Q0iBzF3PcN6LLsH4z8zi[data-has-many] {
    font-size: var(--campaign-info-dynamic-value-font-mobile);
  }
  .Q0iBzF3PcN6LLsH4z8zi[data-timer='true'][data-collapsed='false'][data-has-many='true'] {
    min-width: var(--campaign-info-timer-min-width-multi-view-mobile);
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .yKZxZ7_zTJ8Er0w7_dcD {
    font-size: var(--campaign-info-label-font-has-many-multi-landscape);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .yKZxZ7_zTJ8Er0w7_dcD {
    font-size: var(--campaign-info-label-font-has-many-multi-landscape);
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .RZToHNGn3SEYLQcQDiiv,
  .w2fatjfcfjSZhNxKllsl {
    gap: var(--campaign-info-elements-gap-has-many-multi-portrait);
  }
  .yKZxZ7_zTJ8Er0w7_dcD {
    font-size: var(--campaign-info-label-font-has-many-multi-mobile, 10px) !important;
  }
  .Q0iBzF3PcN6LLsH4z8zi {
    font-size: var(--campaign-info-dynamic-value-font-has-many-multi-portrait, 10px) !important;
  }
  .w2fatjfcfjSZhNxKllsl img,
  .w2fatjfcfjSZhNxKllsl svg {
    width: var(--campaign-info-icon-size-has-many-multi-mobile, 14px) !important;
    height: var(--campaign-info-icon-size-has-many-multi-mobile, 14px) !important;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .RZToHNGn3SEYLQcQDiiv,
  .w2fatjfcfjSZhNxKllsl {
    gap: var(--campaign-info-elements-gap-has-many-multi-portrait);
  }
  .yKZxZ7_zTJ8Er0w7_dcD {
    font-size: var(--campaign-info-label-font-has-many-multi-mobile, 10px) !important;
  }
  .Q0iBzF3PcN6LLsH4z8zi {
    font-size: var(--campaign-info-dynamic-value-font-has-many-multi-portrait, 10px) !important;
  }
  .w2fatjfcfjSZhNxKllsl img,
  .w2fatjfcfjSZhNxKllsl svg {
    width: var(--campaign-info-icon-size-has-many-multi-mobile, 14px) !important;
    height: var(--campaign-info-icon-size-has-many-multi-mobile, 14px) !important;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/BottomCardInfo/css/MultiViewCampaignInfoDisplay.module.css"],"names":[],"mappings":"AAAA;EAEE,iEAAiE;AACnE;AACA;AAEA;AACA;AAEA;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,iBAAiB;AACnB;AACA;AAEA;AACA;AAEA;AACA;AAEA;AACA;;EAEE,eAAe;AACjB;AACA;AAEA;AACA;AAEA;AACA;AAEA;AACA;AAEA;AACA;EACE;IACE,sEAAsE;EACxE;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,iEAAiE;EACnE;AACF;AACA;AAAA;EACE;IACE,mEAAmE;EACrE;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,mEAAmE;EACrE;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;;IAEE,8DAA8D;EAChE;EACA;IACE,iFAAiF;EACnF;EACA;IACE,2FAA2F;EAC7F;EACA;;IAEE,4EAA4E;IAC5E,6EAA6E;EAC/E;AACF;AAAA;AAhBA;AAAA;AAAA;AAAA;EACE;;IAEE,8DAA8D;EAChE;EACA;IACE,iFAAiF;EACnF;EACA;IACE,2FAA2F;EAC7F;EACA;;IAEE,4EAA4E;IAC5E,6EAA6E;EAC/E;AACF;AAAA;AAAA;AAAA","sourcesContent":[".labelText {\n  composes: labelText from './base/CampaignInfoDisplay.base.module.css';\n  font-size: var(--campaign-info-label-font-has-many-multi-desktop);\n}\n.dynamicValueWrapper {\n  composes: dynamicValueWrapper from './base/CampaignInfoDisplay.base.module.css';\n}\n.dynamicValue {\n  composes: dynamicValue from './base/CampaignInfoDisplay.base.module.css';\n}\n.dynamicValue[data-has-many='true'] {\n  font-size: var(--campaign-info-dynamic-value-font-has-many-multi-desktop);\n}\n.dynamicValue[data-timer='true'][data-collapsed='false'][data-has-many='true'] {\n  min-width: var(--campaign-info-dynamic-value-timer-min-width);\n  display: inline-block;\n  text-align: start;\n}\n.campaignInfoDisplayContainer {\n  composes: campaignInfoDisplayContainer from './base/CampaignInfoDisplay.base.module.css';\n}\n.campaignInfoDisplayElementsWrapper {\n  composes: campaignInfoDisplayElementsWrapper from './base/CampaignInfoDisplay.base.module.css';\n}\n.totalLeftPrizesCollapsed {\n  composes: totalLeftPrizesCollapsed from './base/CampaignInfoDisplay.base.module.css';\n}\n.imageLabelWrapper img,\n.imageLabelWrapper svg {\n  display: inline;\n}\n.imageLabelWrapper {\n  composes: imageLabelWrapper from './base/CampaignInfoDisplay.base.module.css';\n}\n.finishedContainer {\n  composes: finishedContainer from './base/CampaignInfoDisplay.base.module.css';\n}\n.finishedText {\n  composes: finishedText from './base/CampaignInfoDisplay.base.module.css';\n}\n.hiddenPlaceholder {\n  composes: hiddenPlaceholder from './base/CampaignInfoDisplay.base.module.css';\n}\n@media (--campaign-mobile) {\n  .labelText {\n    font-size: var(--campaign-info-label-font-has-many-multi-mobile, 13px);\n  }\n  .dynamicValue[data-has-many] {\n    font-size: var(--campaign-info-dynamic-value-font-mobile);\n  }\n  .dynamicValue[data-timer='true'][data-collapsed='false'][data-has-many='true'] {\n    min-width: var(--campaign-info-timer-min-width-multi-view-mobile);\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .labelText {\n    font-size: var(--campaign-info-label-font-has-many-multi-landscape);\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) and (--campaign-tablet-portrait-rule) {\n  .campaignInfoDisplayElementsWrapper,\n  .imageLabelWrapper {\n    gap: var(--campaign-info-elements-gap-has-many-multi-portrait);\n  }\n  .labelText {\n    font-size: var(--campaign-info-label-font-has-many-multi-mobile, 10px) !important;\n  }\n  .dynamicValue {\n    font-size: var(--campaign-info-dynamic-value-font-has-many-multi-portrait, 10px) !important;\n  }\n  .imageLabelWrapper img,\n  .imageLabelWrapper svg {\n    width: var(--campaign-info-icon-size-has-many-multi-mobile, 14px) !important;\n    height: var(--campaign-info-icon-size-has-many-multi-mobile, 14px) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelText": `yKZxZ7_zTJ8Er0w7_dcD ${___CSS_LOADER_ICSS_IMPORT_0___.locals["labelText"]}`,
	"dynamicValueWrapper": `Y2O0YRyl7hvj1TQHG5Xj ${___CSS_LOADER_ICSS_IMPORT_0___.locals["dynamicValueWrapper"]}`,
	"dynamicValue": `Q0iBzF3PcN6LLsH4z8zi ${___CSS_LOADER_ICSS_IMPORT_0___.locals["dynamicValue"]}`,
	"campaignInfoDisplayContainer": `ja4HTht59n1byOytks3k ${___CSS_LOADER_ICSS_IMPORT_0___.locals["campaignInfoDisplayContainer"]}`,
	"campaignInfoDisplayElementsWrapper": `RZToHNGn3SEYLQcQDiiv ${___CSS_LOADER_ICSS_IMPORT_0___.locals["campaignInfoDisplayElementsWrapper"]}`,
	"totalLeftPrizesCollapsed": `eP98PbckEgQoqxuPoo3V ${___CSS_LOADER_ICSS_IMPORT_0___.locals["totalLeftPrizesCollapsed"]}`,
	"imageLabelWrapper": `w2fatjfcfjSZhNxKllsl ${___CSS_LOADER_ICSS_IMPORT_0___.locals["imageLabelWrapper"]}`,
	"finishedContainer": `iz3438uL4IdaK0y59yJo ${___CSS_LOADER_ICSS_IMPORT_0___.locals["finishedContainer"]}`,
	"finishedText": `EmqAQ1Mz2234vTYgk0KM ${___CSS_LOADER_ICSS_IMPORT_0___.locals["finishedText"]}`,
	"hiddenPlaceholder": `b3Ehg06ayyGYUuVQ7c70 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hiddenPlaceholder"]}`
};
export default ___CSS_LOADER_EXPORT___;
